import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/lib/auth";
import PlanSelectionModal from "./PlanSelectionModal";

export default function PendingCheckout() {
  const [showModal, setShowModal] = useState(false);
  const [pendingPlan, setPendingPlan] = useState<string | null>(null);
  const triggered = useRef(false);
  const { user } = useAuth();

  useEffect(() => {
    if (triggered.current) return;
    const plan = localStorage.getItem("pendingPlan");
    if (!plan) return;
    triggered.current = true;
    localStorage.removeItem("pendingPlan");

    // Don't force checkout if user is within 7-day free trial
    if (user?.created_at) {
      const daysSinceCreation = (Date.now() - new Date(user.created_at).getTime()) / (1000 * 60 * 60 * 24);
      if (daysSinceCreation < 7) return;
    }

    setPendingPlan(plan);
    setShowModal(true);
  }, [user]);

  return (
    <PlanSelectionModal
      open={showModal}
      defaultPlan={pendingPlan ?? undefined}
      onClose={() => setShowModal(false)}
      closable={false}
    />
  );
}
